<template>
  <div class="main-head">
    <div class="main-head-con">
      <div class="head-logo" @click="clickfhsy">
        <el-image
          style="width: 500px; height: 80px"
          :src="require('@/assets/img/common/logo.png')"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script setup>
// router
import { useRouter } from "vue-router";
const router = useRouter();
// 返回首页
const clickfhsy=()=>{
  router.push({
    path: "/",
    query: {},
  });
}
</script>

<style scoped>
::v-deep .el-link {
  display: block;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
::v-deep .el-link__inner {
  display: block;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
::v-deep .head-search .el-input-group__prepend {
  width: 60px;
}
.main-head {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #ccc;
}
.main-head-con {
  width: 1200px;
  height: 80px;
  margin: auto;
}
.head-logo {
  width: 500px;
  height: 80px;
  float: left;
  cursor: pointer;
}
.head-search {
  width: 300px;
  height: 80px;
  float: right;
  display: flex;
  align-items: center;
}
.head-login {
  float: right;
  width: 200px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-logins {
  margin-left: 10px;
}
.head-logins-dl {
  width: 110px;
  font-size: 14px;
  text-align: right;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.head-logout {
  float: right;
  width: 200px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-logins-dl {
  width: 160px;
}
</style>
